


















import { Component, Prop, Vue } from "vue-property-decorator";
import McText from "./McText";

@Component({
    components: {
        McText
    }
})
export default class StringProperty extends Vue {

    @Prop({ type: String })
    name!: string;

    @Prop({ type: String })
    value!: string;

    @Prop({ type: Boolean, default: false })
    formatted!: boolean;

}
